export default class ClientDeliveryListItem {
  constructor(data = {}) {
    this.salesOrderId = data.salesOrderId || null;
    this.folio = data.folio || 'Sin Folio';
    this.clientName = data.clientName || 'Cliente Mostrador';
    this.storeName = data.storeName || '';
    this.totalItemsOrdered = data.totalItemsOrdered || 0;
    this.totalItemsPending = data.totalItemsPending || 0;
    this.purchaseDate = data.purchaseDate || null;
    this.statusId = data.statusId || null;
    this.statusDescription = data.statusDescription || 'Desconocido';
  }

  // Puedes agregar "Getters" útiles para la vista aquí.
  // Por ejemplo, para colorear el badge en Vuetify/Element:
  get statusColor() {
    return this.statusId === 1 ? 'error' : 'warning';
  }
}
